// extracted by mini-css-extract-plugin
export default {"giftingCartErrorCroutonContainer":"PlwHXW","giftingCartErrorCroutonTitle":"D7GysD"};